import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/utils/cn';

export interface RouteFallbackProps {
  /** Full screen by default; the app's shell gives it only the space between its bars. */
  className?: string;
}

export const RouteFallback: React.FC<RouteFallbackProps> = ({ className = 'min-h-screen' }) => {
  const { t } = useTranslation('common');
  return (
    <div role="status" className={cn('flex items-center justify-center bg-slate-50', className)}>
      <div className="flex flex-col items-center gap-3">
        <div
          className="w-10 h-10 border-4 border-brand-200 border-t-brand-600 rounded-full animate-spin"
          aria-hidden="true"
        />
        <p className="text-sm text-slate-500 font-medium">{t('routes.loading')}</p>
      </div>
    </div>
  );
};
